import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "Service/api/api";

const getUserList = createAsyncThunk("user/getUserList", async () => {
  try {
    const response = await api.user.getUserList();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

const getUser = createAsyncThunk("users/getUser", async (id: number) => {
  try {
    const response = await api.user.getUser(id);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

const getCurrentUser = createAsyncThunk("users/getCurrentUser", async () => {
  try {
    const response = await api.user.getCurrentUser();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export { getUserList, getUser, getCurrentUser };
